
<template>
    <div class="task-center-no-list" v-if="showNoList">
        <img src="../../../assets/images/oldCustomer/no_result.png" alt="">
        <div class="no-coupon-text">{{getNoCouponText}}</div>
    </div>
</template>
<script>
export default {
  name: 'TaskCenterNoList',
  props: ['missionStatus'],
  computed: {
    getNoCouponText () {
      if (this.missionStatus === 2) {
        return this.$t('FoodC_C_Mission_expired_vxOU')
      } else {
        return ''
      }
    },
    showNoList () {
      return this.missionStatus === 2
    }
  }
}
</script>
<style lang="stylus" scoped>
.task-center-no-list
    display flex
    flex-direction column
    align-items center
    img
        width 288px
        height 288px
    .no-coupon-text
        font-family 'Aspira Medium'
        font-size 36px
        color #000000
        text-align center
        font-weight 500
        margin-bottom 200px
        line-height 46px
        padding 0 20px
</style>